import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Breadcrumbs,
  Link,
  Button,
  Paper,
  CircularProgress,
  Alert
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useSnackbar } from 'notistack';
import api from '../../services/api';
import GanttChartManager from '../../components/gantt/GanttChartManager';
import { t } from '../../utils/textUtils';

const GanttChartPage = () => {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  
  // Log project ID to help with debugging
  console.log('GanttChartPage initialized with projectId from URL params:', projectId);
  
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    fetchProject();
  }, [projectId]);
  
  const fetchProject = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await api.get(`/projects/${projectId}`);
      
      if (response.data) {
        setProject(response.data);
      }
    } catch (error) {
      console.error('Error fetching project:', error);
      setError(t('GAGAL MEMUAT DATA PROYEK. SILAKAN COBA LAGI.'));
      enqueueSnackbar(t('GAGAL MEMUAT DATA PROYEK'), { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };
  
  const handleBack = () => {
    navigate(`/projects/${projectId}/detail`);
  };
  
  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <Typography variant="h4" gutterBottom>
            {t('GANTT CHART')}
          </Typography>
          <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />}>
            <Link 
              to="/projects" 
              style={{ textDecoration: 'none', color: '#5D4037' }}
            >
              {t('PROYEK')}
            </Link>
            <Link 
              to={`/projects/${projectId}/detail`} 
              style={{ textDecoration: 'none', color: '#5D4037' }}
            >
              {loading ? t('LOADING...') : project?.name || t('DETAIL PROYEK')}
            </Link>
            <Typography color="text.primary">{t('GANTT CHART')}</Typography>
          </Breadcrumbs>
        </Box>
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={handleBack}
        >
          {t('KEMBALI KE DETAIL PROYEK')}
        </Button>
      </Box>
      
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>
      ) : (
        <Box sx={{ height: 'calc(100vh - 180px)' }}>
          <GanttChartManager projectId={projectId} />
        </Box>
      )}
    </Box>
  );
};

export default GanttChartPage;
